import { change_lcl_vessel_service } from "./entities";
import { getDestinationCharges, getOriginCharges, convertToFormat, isEstimatedCharges } from "../util/getOriginDestinationCharges";
import { isSameDestinationDischarge } from "../util/isSameDestinationDischarge";

const EXCLUDED_CHARGE_CODES = ["THC08", "FRT61", "CAR33", "CAR83"];


const normalizeEquipmentType = (equipmentSizeType = "") => {
  const upper = (equipmentSizeType || "").toUpperCase();
  if (upper === "40HQ") return "40HC";
  if (upper === "45HQ") return "45HC";
  if (upper === "20DV") return "20ST";
  if (upper === "20GP") return "20ST";
  return upper;
};

const getSpotOnChargesByEquipment = (spotOnSurcharges, sectionKey) => {
  const chargesMap = {};
  if (!Array.isArray(spotOnSurcharges)) {
    return chargesMap;
  }

  spotOnSurcharges.forEach((surcharge) => {
    const key = normalizeEquipmentType(surcharge?.equipmentSizeType);
    if (!key) return;
    const charges = surcharge?.[sectionKey];
    if (Array.isArray(charges) && charges.length > 0) {
      chargesMap[key] = charges;
    }
  });

  return chargesMap;
};

/**
 * @function
 * @name setting_JSON_For_Redux
 * @description will return the rates based multiplying with global profit percent
 * @return return object, containing rates with global profit
 * @param rates_object current iteration of buying rate
 * @param rates_from_bb object for final store
 * @param pos
 * @param query_parameter
 * @param quote_check
 */

export async function setting_JSON_For_Redux(
  getstate,
  rates_object,
  rates_from_bb,
  pos,
  query_parameter,
  requestFromClient = false
) {
  // console.log("setting_JSON_For_Redux_Store........",getstate(),
  // "\n rates_object: ",rates_object)
  const locationToCompany =  rates_object?.location_to?.company_name || rates_object?.location_to?.companyName;
  // console.log("==== locationToCompany =====",locationToCompany)
  let doorFee = rates_object?.door_fee
  let doorFeeFcl = rates_object?.door_fee_fcl;
  let doorFeeLcl = rates_object?.door_fee_lcl;
  // console.log("Door fee: ", rates_object?.door_fee, doorFeeFcl, doorFeeLcl)
  if (!doorFee && !rates_object?.to_door_default && !(locationToCompany || "").includes("Montreal")) {
      doorFeeFcl = 0
      doorFeeLcl = 0
  }

  if (rates_object.rate_type === "FCL") {
    rates_from_bb.rates.fcl[pos] = await mapping_value_in_FCL_And_LCL(
      rates_object,
      query_parameter,
      requestFromClient,
      getstate
    );

    //console.log("========= rates_from_bb.rates.fcl[pos] =======",rates_from_bb.rates.fcl[pos])
    rates_from_bb.rates.fcl[pos]["20st"] = rates_object._20price;
    rates_from_bb.rates.fcl[pos]["40st"] = rates_object._40price;
    rates_from_bb.rates.fcl[pos]["40hq"] = rates_object._40hqPrice;
    rates_from_bb.rates.fcl[pos]["45hq"] = rates_object._45price;
    rates_from_bb.rates.fcl[pos].existingRateSheetCharges =
      rates_object?.existingRateSheetCharges;
  } else {
    // console.log("--lcl-----")
    rates_from_bb.rates.lcl[pos] = await mapping_value_in_FCL_And_LCL(
      rates_object,
      query_parameter,
      requestFromClient,
      getstate
    );
    rates_from_bb.rates.lcl[pos].existingRateSheetCharges =
      rates_object?.existingRateSheetCharges;
    rates_from_bb.rates.lcl[pos].sealine = "Prime Freight Console";
    rates_from_bb.rates.lcl[pos].avatar =
      "https://assets.bettyblocks.com/da93364a2-9d0e141d60e3426481b539f85aaaf6b2/643552/high-resolution-dark.png";
    rates_from_bb.rates.lcl[pos]["rate"] = Number(rates_object?.unit_cost);
  }

   const isSpotOn = Boolean(rates_object?.spotRate ?? rates_object?.spot_rate)

  if (rates_object.rate_type === "FCL") {
    // console.log("------FCL-----", rates_object)
    if (rates_object?.door_fee || rates_object?.to_door_default) {
      // const door_fee = rates_object?.door_fee_fcl;
      rates_from_bb.rates.fcl[pos]["20st"] =
        rates_from_bb.rates.fcl[pos]["20st"] - doorFeeFcl;
      rates_from_bb.rates.fcl[pos]["40st"] =
        rates_from_bb.rates.fcl[pos]["40st"] - doorFeeFcl;
      rates_from_bb.rates.fcl[pos]["40hq"] =
        rates_from_bb.rates.fcl[pos]["40hq"] - doorFeeFcl;
      rates_from_bb.rates.fcl[pos]["45hq"] =
        rates_from_bb.rates.fcl[pos]["45hq"] &&
        rates_from_bb.rates.fcl[pos]["45hq"] !== 0 &&
        rates_from_bb.rates.fcl[pos]["45hq"] - doorFeeFcl;
      const shouldAutoCheckDelivery = isSpotOn && Boolean(rates_object?.door_fee);
      rates_from_bb.rates.fcl[pos].delivery_checked = shouldAutoCheckDelivery ? true : false;
      rates_from_bb.rates.fcl[pos].delivery_checkable = !shouldAutoCheckDelivery;
      // rates_from_bb.rates.fcl[pos].door_fee = door_fee
      rates_from_bb.rates.fcl[pos].delivery_section = [
        {
          name: "Already included",
          //rate: [["FCL", "FCL Delivery.", doorFeeFcl, false, doorFeeFcl, 18]],
          rate: [["FCL", "FCL Delivery.", doorFeeFcl, "CTN", doorFeeFcl, 18]],
          currency: "USD",
          description:
            "Delivery within " +
            (rates_object.location_to.company_name || rates_object.location_to.companyName) +
            " limits",
          lcl_min_rate: null,
          // multiply: true,
          unit_code: "CTN",
          id: "0",
          fetch_zip_code: false,
        },
        {
          name: "To Door Delivery",
          // rate: [["FCL", "FCL Delivery.", 0, true, 0, 9]],
          rate: [["FCL", "FCL Delivery.", 0, "CTN", 0, 9]],
          currency: "USD",
          description: "Delivery",
          lcl_min_rate: null,
          //multiply: true,
          unit_code: "CTN",
          id: "1",
          fetch_zip_code: true,
        },
      ];
    } else {
      rates_from_bb.rates.fcl[pos].delivery_checkable = true;
      rates_from_bb.rates.fcl[pos].delivery_section = [
        {
          name: "To Door Delivery",
          // rate: [["FCL", "FCL Delivery.", doorFeeFcl, false, doorFeeFcl, 18]],
          rate: [["FCL", "FCL Delivery.", doorFeeFcl, "CTN", doorFeeFcl, 18]],
          currency: "USD",
          description:
            "Delivery within " +
            (rates_object.location_to.company_name || rates_object.location_to.companyName) +
            " limits",
          lcl_min_rate: null,
          //multiply: true,
          unit_code: "CTN",
          id: "0",
          fetch_zip_code: true,
        },
        {
          name: "Variable Rate",
          rate: "440.00",
          currency: "USD",
          description:
            "Prime Freight will advise of the cartage costs before proceeding with the shipment",
          lcl_min_rate: null,
          // multiply: true,
          unit_code: "CTN",
          show_variable_rate: true,
          id: "2",
        },
      ];
    }
  } else {
    if (rates_object?.door_fee || rates_object?.to_door_default) {
      // const door_fee = rates_object?.door_fee_lcl;
      // console.log("=== door fee ====",rates_object?.door_fee,"doorFeeLcl: ",doorFeeLcl)
      rates_from_bb.rates.lcl[pos]["rate"] =
        rates_from_bb.rates.lcl[pos]["rate"] - doorFeeLcl;
      rates_from_bb.rates.lcl[pos].delivery_checked = false;
      rates_from_bb.rates.lcl[pos].delivery_checkable = true;
      rates_from_bb.rates.lcl[pos].delivery_section = [
        {
          name: "Already included",
          // rate: [["LCL", "LCL Delivery.", doorFeeLcl, true, doorFeeLcl, 9]],
          rate: [["LCL", "LCL Delivery.", doorFeeLcl, "CBM", doorFeeLcl, 9]],
          currency: "USD",
          description:
            "Delivery within " +
            (rates_object.location_to.company_name || rates_object.location_to.companyName) +
            " limits",
          lcl_min_rate: null,
          // multiply: true,
          unit_code: "CBM",
          id: "0",
          fetch_zip_code: false,
        },
      ];
    } else {
      // console.log("---no door fee------")
      rates_from_bb.rates.lcl[pos].delivery_checkable = true;
      let fetchZipCode = true;
      // TODO: remove
      // if (rates_from_bb.rates.lcl[pos].dataSource === "api") {
      //   fetchZipCode = true;
      // }
      // rates_from_bb.rates.lcl[pos].delivery_checkable = true;
      rates_from_bb.rates.lcl[pos].delivery_section = [
        {
          name: "To Door Delivery",
          // rate: [["LCL", "LCL Delivery.", doorFeeLcl, true, doorFeeLcl, 9]],
          rate: [["LCL", "LCL Delivery.", doorFeeLcl, "CBM", doorFeeLcl, 9]],
          currency: "USD",
          description:
            "Delivery within " +
            (rates_object.location_to.company_name || rates_object.location_to.companyName) +
            " limits",
          lcl_min_rate: null,
          // multiply: true,
          unit_code: "CBM",
          id: "0",
          //fetch_zip_code: false,
          fetch_zip_code: fetchZipCode,
        },
        {
          name: "Variable Rate",
          rate: "440.00",
          currency: "USD",
          description:
            "Prime Freight will advise of the cartage costs before proceeding with the shipment",
          lcl_min_rate: null,
          // multiply: true,
          unit_code: "CBM",
          show_variable_rate: true,
          id: "2",
        },
      ];
    }
    //  else{

    //  }
  }
  // console.log("rates_from_bb: ",rates_from_bb)
  return rates_from_bb;
}

async function mapping_value_in_FCL_And_LCL(
  rates_object,
  query_parameter,
  requestFromClient,
  getstate
) {
  //console.log("--mapping values------- , rates_object",rates_object, query_parameter, requestFromClient)
  const defaultDestinationCharges = getstate()?.route?.defaultDestinationCharges;
  
  let excludedCharges = [];
  const webuser = getstate()?.route?.USER_DETAILS?.webuser;
  if (webuser && webuser?.userid) {
    excludedCharges = getstate()?.route?.rateProfile?.excluded_charges;
  }
  
  const locationToCompany = rates_object?.location_to?.company_name || rates_object?.location_to?.companyName;
  const isMontreal = locationToCompany?.toLowerCase().includes('montreal');
  const rateDestCharges = (!isMontreal && rates_object?.destinationCharges) ? rates_object.destinationCharges : [];

  const originChargesArr = getOriginCharges(rates_object?.originCharges, rates_object)
  // console.log("originChargesArr: ",originChargesArr);

  const { destinationCharges: destinationChargesArr, isEstimated: destinationChargesEstimated } = getDestinationCharges(
    defaultDestinationCharges,
    rateDestCharges,
    excludedCharges,
    rates_object
  );

  // Per-side estimate state for the card: a side is "estimated" when any of its charge rows is an
  // estimate. The rate-api may also supply meta (source/confidence/currency/fxDate/ttl) which we
  // carry through for the badge tooltip and the booking-confirmation rule.
  const originChargesEstimated = isEstimatedCharges(originChargesArr);

  // Compute default and API portions separately so the reducer can replace
  // only the API charges on refresh without touching the default charges
  const excludedIds = new Set((excludedCharges || []).map(c => c?.id || c?.chargeId));
  const filteredDefaultCharges = (defaultDestinationCharges || []).filter(
    c => !excludedIds.has(c.id)
  );
  const portFeesToDefault = convertToFormat(filteredDefaultCharges.filter(c => c.chargeIden !== 'OVERSEAS'));
  const portFeesToApi = convertToFormat(rateDestCharges.filter(c => c.chargeIden !== 'OVERSEAS'));
  // vessel service is empty
  if (rates_object.vessel_service === null) {
    rates_object.vessel_service = {
      name: (rates_object?.carrier?.company_name || rates_object?.carrier?.companyName),
      id: rates_object?.carrier?.id,
    };

    rates_object = await change_lcl_vessel_service(rates_object);
  } else {
    rates_object = await change_lcl_vessel_service(rates_object);
  }
  // vendor contract is empty

  if (rates_object.vendor_contract === null) {
    rates_object.vendor_contract = {
      name: (rates_object?.carrier?.company_name || rates_object?.carrier?.companyName),
      id: rates_object?.carrier?.id,
    };
  }
 // const isSpotOn = Boolean(rates_object?.spotRate ?? rates_object?.spot_rate);
 const unitCode = rates_object?.rate_type === "FCL" ? "CTN" : "CBM";

  //  setting object
  let object = {
    uuid: rates_object?.uuid,
    id: rates_object.id,
    charge_id: rates_object?.chargeId,
    charge_type_id: rates_object?.chargeTypeId,
    mode: rates_object?.mode,
    rate_type: rates_object?.rate_type,
    currency: rates_object?.currency,
    buyingRate: rates_object.buying_rate,
    // TODO: REMOVE dummy fallback once API returns buying data
    buying_rates_data:  rates_object.buying_rates_data,
    buying_avg_rate:  rates_object.buying_avg_rate,
    NAC_percentage: rates_object?.NAC_percentage,
    FAK_percentage: rates_object?.FAK_percentage,
    schedulesTransitTime: rates_object?.schedules_transit_time,
    dataSource: rates_object?.data_source,
    spotRate: Boolean(rates_object?.spotRate ?? rates_object?.spot_rate),
    externalRateType: rates_object?.external_rate_type,
    prepaidCollect: rates_object?.prepaidCollect,
    transshipments: rates_object?.transshipments,
    schedules: rates_object?.schedules,
    local_schedule_key: rates_object?.local_schedule_key,
    transitTime: rates_object?.transit_time,
    portTransitTime: rates_object?.portTransitTime,
    door_fee: rates_object?.door_fee,
    door_fee_fcl: rates_object?.door_fee_fcl,
    door_fee_lcl: rates_object?.door_fee_lcl,
    to_door_default: rates_object?.to_door_default,
    // "transitTime": (rates_object?.schedulesTransitTime ?? rates_object?.transitTime),
    thc_exp: true,
    thc_imp: false,
    fee_exp: false,
    fee_imp: false,
    origin_checked: false,
    freight_checked: true,
    discharge_checked: true,
    origin_checkable: true,
    freight_checkable: false,
    discharge_checkable: false,
    is_estimate: false,
    is_freight_estimate: rates_object?.isEstimate || false,
    valid_date_from: rates_object.validity_from,
    valid_date_to: rates_object.validity_to,
    location_from: rates_object?.location_from,
    location_to: rates_object?.location_to,
    port_of_origin:
      rates_object?.location_from?.company_name ||
      rates_object?.location_from?.companyName,
    // "port_of_discharge": rates_object.viaPort.companyName,
    port_of_discharge: rates_object?.via_port,
    company_link: ( rates_object?.carrier?.company_website || rates_object?.carrier?.companyWebsite )
      ? (rates_object?.carrier?.company_website || rates_object?.carrier?.companyWebsite)
      : "",
    carrier_scac_code: rates_object?.carrier?.scac_code || rates_object?.carrier?.scacCode,
    company_about: rates_object?.carrier?.company_about || rates_object?.carrier?.companyAbout,
    schedule_website_link: rates_object?.carrier?.schedule_website_link || rates_object?.carrier?.scheduleWebsiteLink,
    avatar: rates_object?.carrier?.company_avatar_image?.url || rates_object?.carrier?.companyAvatarImage?.url,
    description: requestFromClient
      ? rates_object?.schedules
        ? `Rates are valid from ${rates_object.validity_from} Till ${rates_object.validity_to}`
        : `Vessel service-: ${rates_object.vessel_service.name}. Rates are valid from ${rates_object.validity_from} Till ${rates_object.validity_to}`
      : "Vessel service-: " +
        rates_object.vessel_service.name +
        ". Rates are valid from " +
        rates_object.validity_from +
        " Till " +
        rates_object.validity_to,
    ers_checked: true,
    ers_checkable: false,
    ers_location: rates_object?.location_to?.company_name || rates_object?.location_to?.companyName,
    ers_selected_option: 0,
    vessel_Service: rates_object?.vessel_service,
    vendor_contract: rates_object?.vendor_contract,
    etd_origin: query_parameter?.etd_origin,
    updatePickupDeliveryErsLine: {},
    originCharges: rates_object?.originCharges,
    destinationCharges: rates_object?.destinationCharges,
    ers_section: [
      {
        name: "Regular Rail Service",
        // rate: [["Included", "", "0", false, "0"]],
        rate: [["Included", "", "0", "EA", "0"]],
        currency: "USD",
        // multiply: true,
        unit_code: unitCode,
        id: "0",
        fetch_zip_code: false,
        description: "",
      },
      {
        name: "ERS Expedited Rail Service",
        // rate: [["EXP1", "Expedite Charge", "200", true, "200", 153]],
        rate: [["EXP1", "Expedite Charge", "200", unitCode, "200", 153]],
        currency: "USD",
        // multiply: true,
        unit_code: unitCode,
        id: "1",
        fetch_zip_code: false,
        description:
          "Save up to 3 days of transit time and avoid additional port delays with priority rail service",
      },
    ],
    sealine: rates_object?.carrier?.company_name || rates_object?.carrier?.companyName,
    carrier: rates_object?.carrier,
    pickup_checked: false,
    pickup_checkable: true,
    pickup_selected_option: 0,
    pickup_section: [
      {
        name: "Pickup",
        currency: "USD",
        description: "Pickup",
        lcl_min_rate: null,
        // multiply: true,
        unit_code: unitCode,
        id: "0",
        fetch_zip_code: true,
      },
      {
        name: "Variable Rate",
        rate: "440.00",
        currency: "USD",
        description:
          "Prime Freight will advise of the cartage costs before proceeding with the shipment",
        lcl_min_rate: null,
        // multiply: true,
        unit_code: unitCode,
        show_variable_rate: true,
        id: "2",
      },
    ],
    delivery_checked: false,
    delivery_checkable: false,
    delivery_selected_option: 0,

    // // port of origin
    // port_fees_from: [
    //   [
    //     "Variable Charge",
    //     "Variable Charge: Prime Freight will advise of the final origin charges after booking",
    //     "",
    //     false,
    //     "",
    //   ],
    // ],
    // // discharge
    // port_fees_to: [
    //   [
    //     "LLEO",
    //     "Legal Liability, Errors and Omissions Insurance",
    //     "5",
    //     false,
    //     "5",
    //     284,
    //   ],
    //   ["HBL", "HBL Fee", "25", false, "25", 431],
    //   ["ACI", "ACI", "30", false, "30.00", 543],
    // ],
    port_fees_from: originChargesArr,
    port_fees_from_default: [
      [
        "Variable Charge",
        "Variable Charge: Prime Freight will advise of the final origin charges after booking",
        "",
        false,
        "",
      ],
    ],
    port_fees_from_api: originChargesArr,     // selling-rate origin charges; replaced by SET_EXTERNAL_API_ORIGIN_CHARGES when postal charges arrive
    // Use backend destination charges instead of hardcoded ones
    port_fees_to: destinationChargesArr,
    port_fees_to_default: portFeesToDefault,
    port_fees_to_api: portFeesToApi,
    destination_extra_charges: [],
    // Per-side estimate state (port-charges feature). Flags drive the booking-confirmation rule;
    // meta (from rate-api) drives the badge confidence/tooltip. Firm sources leave these false/null.
    origin_charges_estimated: originChargesEstimated,
    destination_charges_estimated: destinationChargesEstimated,
    origin_charges_meta: rates_object?.originChargesMeta || null,
    destination_charges_meta: rates_object?.destinationChargesMeta || null,
    spot_on_surcharges: Array.isArray(rates_object?.spot_on_surcharges)
      ? rates_object?.spot_on_surcharges
      : [],
  };

  if(object?.spotRate){
    // console.log("---spot rate-------")
    object = {
      ...object,
      ers_section: [
       {
        name: "Regular Rail Service",
        //rate: [["Included", "", "0", false, "0"]],
        rate: [["Included", "", "0", "EA", "0"]],
        currency: "USD",
        // multiply: true,
        unit_code: unitCode,
        id: "0",
        fetch_zip_code: false,
        description: "",
      },
      ],
      // port_fees_to: [
      //   [
      //     "Variable Charge",
      //     "Variable Charge: Prime Freight will advise of the final origin charges after booking",
      //     "0",
      //     // false,
      //     "EA", // unit_code (replaces multiply flag)
      //     "0",
      //     "",
      //   ],
      // ]
      port_fees_to: destinationChargesArr,
    }
  }

  if (object?.spot_on_surcharges?.length > 0) {
    const originChargesByEquipment = getSpotOnChargesByEquipment(
      object.spot_on_surcharges,
      "originCharges"
    );
    if (Object.keys(originChargesByEquipment).length > 0) {
      object.originChargesByEquipment = originChargesByEquipment;
      const originCharges = Object.entries(originChargesByEquipment).flatMap(
        ([equipmentTypecode, charges]) =>
          charges.map(charge => (
            [
            charge[0],
            charge[1],
            charge[2],
            charge[3],
            charge[4],
            charge[5],
            equipmentTypecode
            ]
        ))
      );
      object.port_fees_from = originCharges || []

      if (
        Array.isArray(object.port_fees_from) &&
        object.port_fees_from.length > 0 &&
        object.port_fees_from[0][0] !== "Variable Charge"
      ) {
        object.origin_checked = true;
        object.origin_checkable = false
      }

    } 

    const destinationChargesByEquipment = getSpotOnChargesByEquipment(
      object.spot_on_surcharges,
      "destinationCharges"
    );
    if (Object.keys(destinationChargesByEquipment).length > 0) {
      object.destinationChargesByEquipment = destinationChargesByEquipment;
      const destinationCharges = Object.entries(destinationChargesByEquipment).flatMap(
        ([equipmentTypecode, charges]) =>
          charges.map(charge => [
            charge[0],
            charge[1],
            charge[2],
            charge[3],
            charge[4],
            charge[5],
            equipmentTypecode
          ]
        )
      );
      object.port_fees_to = destinationCharges || []

    } 

    const freightChargesByEquipment = getSpotOnChargesByEquipment(
      object.spot_on_surcharges,
      "freightCharges"
    );
    if (Object.keys(freightChargesByEquipment).length > 0) {
      object.freightChargesByEquipment = freightChargesByEquipment;
      const freightCharges = Object.entries(freightChargesByEquipment).flatMap(
        ([equipmentTypecode, charges]) =>
          charges.map(charge => ({
            charge_code: charge[0],
            charge_description: charge[1],
            minimum_price: charge[2],
            // multiply: charge[3],
            unit_code: charge[3],
            price: charge[4],
            chargetype_id: charge[5],
            equipmentTypecode
          }))
      );
      object.freightCharges = freightCharges || []

    }
    // console.log("---------freightChargesByEquipment------",freightChargesByEquipment,
    //   "\nfreightCharges: ",object.freightCharges
    // )
    // ----- CHECK FOR OVERWEIGHT -----
    const containsOverweightCode = (charges) =>
      charges.some(charge => {
        const description = (charge[1] || "").toUpperCase();
        return EXCLUDED_CHARGE_CODES.some(code =>
          description.includes(code.toUpperCase())
        );
      });

      // Check both origin and destination
    if (
      Object.values(originChargesByEquipment || {}).some((charges) =>
        containsOverweightCode(charges || [])
      ) ||
      Object.values(destinationChargesByEquipment || {}).some((charges) =>
        containsOverweightCode(charges || [])
      ) ||
      // containsOverweightCode(freightCharges || []) ||
      Object.values(freightChargesByEquipment || {}).some((charges) =>
        containsOverweightCode(charges || [])
      )
    ) {
      object.isOverweight = true;
      const fclWeights = getstate()?.code_config?.fclWeights
      object = {
        ...object,
        ...fclWeights
      }
    }
  }

  // console.log("object.port_fees_from: ",object.port_fees_from,
  //   "\nobject.port_fees_to: ",object.port_fees_to
  // )
  

  // when destination and discharge is same. via_port is nullable (LCL consolidation lanes carry no
  // discharge port); isSameDestinationDischarge guards both ids so a missing via_port can't throw.
  if (isSameDestinationDischarge(rates_object)) {
    object.ers_checked = false;
    object.ers_checkable = false;
  }

  // // Add OVERSEAS charge conditionally based on ORIGIN port ID and spotOn check
  // if (rates_object.location_from.id === 653441 && !isSpotOn && overseasCharge) {
  //     if (rates_object.rate_type === "FCL") {
  //       // console.log("Adding OVERSEAS charge from backend for origin port 653441 (non-spot rate)");
        
  //       // Convert backend OVERSEAS charge to expected format
  //       const overseasChargeFormatted = [
  //         overseasCharge.chargeIden,
  //         overseasCharge.description,
  //         overseasCharge.unitCost,
  //         //overseasCharge.unitCode === "CTN" ? true : false, // multiply flag based on backend unitCode
  //         overseasCharge.unitCode,
  //         overseasCharge.unitCost,
  //         overseasCharge.id,
  //       ];
        
  //       object.port_fees_to.push(overseasChargeFormatted);
  //     }
  // } else if (rates_object.location_from.id === 653441 && !isSpotOn && !overseasCharge) {
  //   console.log("OVERSEAS charge not found in backend data for origin port 653441");
  // }
    
  // console.log("Final destinationCharges with OVERSEAS logic: ", object.port_fees_to);
  return object;
}
